module.exports = __webpack_public_path__ + "static/media/uldaCentenario.d515df71.webp";